
import {Component, Vue, Prop, Emit} from 'vue-property-decorator';
import {userApi, classesApi} from '@/api';

interface Phone {
    mobile: string;
    code: string;
}

@Component
export default class UserInfoEdit extends Vue {
    @Prop({default: []}) userInfo?: any;
    @Emit('closeModal') private closeModal() {}
    loading: boolean = false;
    editPassword: boolean = false;
    showEditPhone: boolean = false;
    codeText: string = '获取验证码';
    errorVerifyCode: boolean = false;
    errorVerifyPhone: boolean = false;

    get userId() {
        return this.$store.getters['account/userId'];
    }
    checkNickName = function (rule: any, value: any, callback: any) {
        if (value) {
            if (!/[a-zA-Z0-9_\u4e00-\u9fa5- _.~!@#\$%\^&\*\(\)\+=\|\\\}\]\{\[:;<,>\?\/""]*/g.test(value)) {
                callback(new Error('仅支持中/英文、数字和下划线或其他符号'));
            } else {
                callback();
            }
        }
        callback();
    };

    checkData = function (rule: any, value: any, callback: any) {
        if (value) {
            if (!/^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-9])\d{8}$/.test(value)) {
                callback(new Error('请输入正确的手机号!'));
            } else {
                callback();
            }
        }
        callback();
    };

    // 密码输入框不支持中文的验证规则
    changeKey = function (rule: any, value: any, callback: any) {
        if (value === '') {
            callback();
        }
        //定义你需要的正则
        let rgx = /^(?!_)(?!.*?_$)[a-zA-Z0-9_]+$/;
        if (rgx.test(value)) {
            //验证通过调用回调函数
            callback();
        } else {
            callback(new Error('只允许包含数字、字母、下划线'));
        }
    };

    formEditPhone: Phone = {
        mobile: '',
        code: ''
    };
    formRulesEditPhone: any = {
        mobile: [
            {
                required: true,
                message: '请输入新手机号',
                trigger: 'blur'
            },
            {
                min: 11,
                max: 11,
                message: '请输入11位手机号',
                trigger: 'blur'
            },
            {validator: this.checkData, trigger: 'change'}
        ],
        code: [
            {
                required: true,
                message: '请输入验证码',
                trigger: 'blur'
            },
            {
                min: 6,
                max: 6,
                message: '请输入6位验证码',
                trigger: 'blur'
            }
        ]
    };

    formInfo: any = {
        nickname: '',
        sex: '',
        username: '',
        password: 'password',
        mobile: '',
        address: '',
        schoolname: '',
        roles: [],
        _id: ''
    };

    formRulesInfo: any = {
        nickname: [
            {
                required: true,
                message: '请输入学校管理员姓名',
                trigger: 'blur'
            },
            {
                max: 20,
                message: '最大长度20个字符',
                trigger: 'blur'
            },
            {validator: this.checkNickName, trigger: 'change'}
        ],
        mobile: [
            {
                required: false,
                message: '请输入手机号码',
                trigger: 'blur'
            },
            {
                min: 11,
                max: 11,
                message: '请输入11位手机号',
                trigger: 'blur'
            },
            {validator: this.checkData, trigger: 'change'}
        ],
        password: [
            {
                required: true,
                message: '请输入登录密码',
                trigger: 'blur'
            },
            {
                min: 6,
                message: '请输入不少于6位的密码',
                trigger: 'blur'
            },
            {validator: this.changeKey, trigger: 'change'}
        ]
    };
    state: any = {
        count: 60,
        timer: null
    };

    handleCancel() {
        this.$emit('closeModal');
    }
    handleEditPassword() {
        this.formInfo.password = '';
        this.editPassword = true;
    }
    handleEditPhone() {
        this.showEditPhone = true;
    }
    clear() {
        if (this.state.timer) {
            clearInterval(this.state.timer);
        }
        this.state.count = 60;
        this.codeText = '获取验证码';
    }
    handleGetCode() {
        let me = this;
        (me.$refs.editPhoneForm as any).validateField('mobile', (valid: any) => {
            if (!!valid === false) {
                if (me.codeText === '获取验证码' || me.codeText === '重新获取') {
                    let urlParamObj = {
                        mobile: me.formEditPhone.mobile,
                        type: 'bandingMobile'
                    };
                    userApi.getCode({
                        urlParams: urlParamObj,
                        success(data: any, parameters: any) {
                            me.state.timer = setInterval(() => {
                                me.state.count--;
                                me.codeText = `${me.state.count}S`;
                                if (me.state.count <= 0) {
                                    me.clear();
                                }
                            }, 1000);
                        },
                        error(error: any, message: any, parameters: any) {
                            if (message === '超过当日上限次数' || message === '服务器异常！') {
                                me.$message.error('今天的验证码获取次数已达上限');
                            } else {
                                me.$message.error('验证码发送失败，请重新获取');
                            }
                            me.codeText = '重新获取';
                            return;
                        }
                    });
                }
            }
        });
    }
    handleEditPhoneCancel() {
        this.showEditPhone = false;
        this.formEditPhone.mobile = '';
        this.formEditPhone.code = '';
        this.clearVerifyPhoneError();
        this.clearVerifyCodeError();
        if (this.codeText === '重新获取') {
            this.clear();
        }
    }
    handleEditPhoneOk() {
        let me = this;
        (me.$refs.editPhoneForm as any).validate((valid: any) => {
            if (!!valid === true) {
                let urlParamObj = {
                    username: me.formInfo.username,
                    mobile: me.formEditPhone.mobile,
                    code: me.formEditPhone.code
                };
                userApi.validateCodeChangePhone({
                    data: urlParamObj,
                    success(data: any, parameters: any) {
                        me.formInfo.mobile = me.formEditPhone.mobile;
                        me.userInfo.mobile = me.formEditPhone.mobile;
                        me.$app.setState(me.userInfo);
                        me.$message.success('操作成功！手机号已更换。');
                        me.handleEditPhoneCancel();
                    },
                    error(error: any, message: any, parameters: any) {
                        if (message === '验证码错误') {
                            me.errorVerifyCode = true;
                        }
                        if (message === '该手机号已被使用') {
                            me.errorVerifyPhone = true;
                        }
                    }
                });
            }
        });
    }
    clearVerifyPhoneError() {
        this.errorVerifyPhone = false;
    }
    clearVerifyCodeError() {
        this.errorVerifyCode = false;
    }
    handleOk() {
        let me = this;
        me.loading = true;
        let form = JSON.parse(JSON.stringify(me.formInfo));
        delete form.address;
        delete form.sex;
        delete form.username;
        delete form.schoolname;
        delete form.mobile;
        if (!me.editPassword) {
            delete form.password;
        }
        userApi.saveRecord({
            context: me,
            data: form,
            success(data: any, parameters: any) {
                me.userInfo.nickname = me.formInfo.nickname;
                me.userInfo.mobile = me.formInfo.mobile;
                me.$app.setState(me.userInfo);
                me.$message.success('修改成功');
                me.$emit('closeModal');
                me.loading = false;
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
                me.$emit('closeModal');
                me.loading = false;
            }
        });
    }
    //获取学校信息
    initOrganization() {
        let me = this;
        classesApi.getSchoolById({
            context: this,
            urlParamObj: {
                id: me.userInfo.schoolId
            },
            success(data: any, parameters: any) {
                let domain = data.data;
                me.formInfo.address = domain.address;
                me.formInfo.schoolname = domain.name;
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    getUserInfo() {
        this.formInfo.nickname = this.userInfo.nickname;
        this.formInfo.mobile = this.userInfo.mobile;
        this.formInfo.username = this.userInfo.username;
        this.formInfo.roles = this.userInfo.roles;
        this.formInfo._id = this.userInfo._id;
        if (this.userInfo.sex) {
            this.formInfo.sex = this.userInfo.sex;
        } else {
            this.formInfo.sex = null;
        }
    }

    created() {
        this.getUserInfo();
        this.initOrganization();
    }
}
